<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Guidebook Preview'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (!isDataLoaded) {
      <div style="width: 100%">
        <ion-skeleton-text animated="true" style="height: 200px; border-radius: 12px" />
      </div>
    }

    @if (isDataLoaded && guidebookConfig) {
      <tidy-alert>
        <tidy-row>
          <tidy-image
            [src]="'assets/svg/eye-outline.svg'"
            class="body-size" />
          <tidy-text
            [body]="'Preview Mode'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'This is how your guest will see the guidebook. Each reservation gets a unique URL.'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="guidebookUrl"
            [translate]="false" />
        </tidy-row>
      </tidy-alert>

      <div class="iphone-frame-container">
        <div class="iphone-frame">
          <div class="iphone-notch"></div>
          <div class="iphone-screen">
            <iframe
              [src]="iframeUrl"
              class="guidebook-iframe"
              frameborder="0"
              title="Guidebook Preview">
            </iframe>
          </div>
          <div class="iphone-home-bar"></div>
        </div>
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content>
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
